module.exports = __webpack_public_path__ + "img/sb2.4682aa59.gif";